import { createContext } from "react";

export const OrganizationModalContext = createContext();
